import styles from './MainHeader.module.scss';

export const MainHeader = (): JSX.Element => (
	<div id="main" className={styles.mainHeader}>
		<h1>Auto-pneu-servis</h1>
		<h2>Kraslice</h2>
		<h3>Jaroslav Svátek</h3>
	</div>
);
